import React from "react";

import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { useAppContext } from "@state/hooks/shared";
import { THEME_SETTINGS } from "@theme-settings";
import { isGamesTheme } from "@utils";
import { isBankIdPasswordlessUser } from "@utils/specific/bankid/bankIdStepUp";
import { observer } from "mobx-react";

import {
	AccountLockItem,
	AccountSettingsCRCItem,
	AccountSettingsSideMenuItem,
	AccountVerificationItem,
} from "./components";

export default observer(function AccountSettingsSideMenu() {
	const rootStore = useRootAppStore();

	const { t } = useTranslation("account-settings-navigation");
	const { culture } = useAppContext();

	return (
		<nav className="nav--tertiary">
			<ul className="nav--tertiary__menu">
				<AccountSettingsSideMenuItem
					path={`/${culture}/account-settings/personal-data`}
					translation={t("PERSONAL_DATA")}
				/>
				{rootStore.userAuthStore.isInternetUser && (
					<AccountVerificationItem
						path={`/${culture}/account-settings/account-verification`}
						translation={t("HEADER.ACCOUNT_VERIFICATION")}
					/>
				)}

				<AccountSettingsCRCItem
					path={`/${culture}/account-settings/credit-rating`}
					translation={t("CREDIT_RATING_CHECK.TITLE")}
				/>

				{!isBankIdPasswordlessUser(rootStore.userAuthStore.user) ? (
					<AccountSettingsSideMenuItem
						path={`/${culture}/account-settings/password-change`}
						translation={t("TITLE_PC")}
					/>
				) : null}

				<AccountSettingsSideMenuItem
					path={`/${culture}/account-settings/email-change`}
					translation={t("TITLE_EC")}
				/>

				<AccountSettingsSideMenuItem
					path={`/${culture}/account-settings/my-limits`}
					translation={t("MY_LIMITS")}
				/>

				<AccountSettingsSideMenuItem
					path={`/${culture}/account-settings/limits-history`}
					translation={t("LIMITS_HISTORY")}
				/>

				{rootStore.userAuthStore.isInternetUser &&
				rootStore.userAuthStore.isAutoWithdrawalEnabled ? (
					<AccountSettingsSideMenuItem
						path={`/${culture}/account-settings/automatic-withdrawal`}
						translation={t("AUTOMATIC_WITHDRAWAL")}
					/>
				) : null}

				<AccountLockItem
					path={`/${culture}/account-settings/account-lock`}
					translation={t("ACCOUNT_CLOSURE_OASIS")}
					secondaryTranslation={t("ACCOUNT_LOCK")}
				/>

				{THEME_SETTINGS.isAutomaticLogoutEnabled ? (
					<AccountSettingsSideMenuItem
						path={`/${culture}/account-settings/automatic-logout`}
						translation={t("AUTOMATIC_LOGOUT")}
					/>
				) : null}

				{!isGamesTheme() && (
					<AccountSettingsSideMenuItem
						path={`/${culture}/account-settings/my-bonuses`}
						translation={t("MY_BONUSES")}
					/>
				)}
			</ul>
		</nav>
	);
});
